const ColumnGroup = () => null;
export default ColumnGroup;
